module.exports = __webpack_public_path__ + "static/media/biocertica-white.b0572f3d.svg";